import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { retryFailed } from '@/server/jobs.functions';

export const useRetryFailed = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: () => retryFailed(),
    onError: (error: Error) => push(error.message || 'Retry failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
    },
  });
};
